'use strict';

angular.module('amexReconciliationApp')
  .component('transactionListContainer', {

    templateUrl: 'scripts/views/components/transaction-list-container.html',
    controller: function ($stateParams,
                          TransactionSearchModel,
                          TransactionService,
                          BillingCycleModel,
                          UserModel,
                          ActiveTransactionModel) {

      var self = this;

      self.isSuperAdmin = UserModel.isSuperAdmin;

      ActiveTransactionModel.clearActiveTransaction();

      if(TransactionSearchModel.isAccountingManager()) {
        TransactionService.getTransactions();
      }

      self.isPageRefreshed = function() {
        return _.isEmpty(BillingCycleModel.billingCycles());
      };

      self.displayRedirectMessage = function() {
        var isSuperAdminOrTransitioning = _.get(UserModel.currentUser(), 'superAdmin', false) || _.isEqual(UserModel.currentUser(), {});

        return _.isEmpty(BillingCycleModel.billingCycles()) && !isSuperAdminOrTransitioning;
      };

      self.refreshUrl = function() {
        return '/#/' + $stateParams.currentRole;
      };
    }
  });




//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/components/transactionListContainer.js
// module id = 491
// module chunks = 0